import { useTranslations } from '@/i18n';
import { Button } from '@/components/ui/button';

interface Expense {
  amount: number;
  currency: string;
  description?: string;
}

interface ExpenseCardProps {
  icon: string;
  title: string;
  onAdd?: () => void;
  expenses?: Expense[];
}

export default function ExpenseCard({ icon, title, onAdd, expenses = [] }: ExpenseCardProps) {
  const t = useTranslations('cityForm');
  return (
    <div className="flex h-[5.375rem] w-full items-center rounded-2xl border border-[#ebebeb] bg-white px-2 py-5">
      <div className="flex h-[4.25rem] w-full items-center justify-between gap-3 rounded-2xl px-3.5 py-2.5">
        <div className="flex min-w-0 flex-1 items-center gap-3">
          <div className="flex items-center justify-center">
            <div className="flex shrink-0 items-center justify-center rounded-[2rem] border border-[#f1f1f1] bg-[#f9f9f9] p-2">
              <img src={icon} alt="" className="size-6" />
            </div>
          </div>
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <div className="flex flex-col">
              <div className="text-[clamp(14px,4.5vw,18px)] leading-[clamp(20px,5vw,28px)] font-medium text-[#292929]">
                {title}
              </div>
              {expenses.length > 0 && (
                <div className="flex items-center gap-2 text-sm text-[#666666]">
                  <span>
                    {expenses.length} {t('expense')}
                  </span>
                  <span>•</span>
                  <span>
                    {expenses.reduce((sum, exp) => sum + exp.amount, 0).toFixed(2)} {t('currency')}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
        <Button
          onClick={onAdd}
          variant="unstyled"
          size="none"
          className="flex shrink-0 items-center justify-center rounded-[1.875rem] bg-[#242424] p-2.5 transition-colors hover:bg-[#333333]"
        >
          <img src="/assets/icons/plus.svg" alt="" className="size-5" />
        </Button>
      </div>
    </div>
  );
}
